// src/utils/convertBase64ToFile.ts

/**
 * Convierte una lista de imágenes en Base64 a archivos File.
 * @param base64Images - Array de strings en formato Base64.
 * @param filename - Nombre base para los archivos generados.
 * @returns Array de archivos File.
 */
export function convertBase64ToFile(base64Images: Array<string>, filename: string): Array<File> {
    return base64Images.map((base64Image, index) => {
      const byteString = atob(base64Image.split(",")[1]);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const intArray = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([intArray], { type: "image/png" });
      // Añadir un sufijo al nombre del archivo si se procesan múltiples imágenes
      const fileSuffix = base64Images.length > 1 ? `_${index + 1}` : '';
      return new File([blob], `${filename}${fileSuffix}.png`, { type: "image/png" });
    });
  }
    /**
   * Convierte un archivo a base64.
   * @param file - El archivo que se va a convertir.
   * @returns Una promesa que se resuelve con el string en formato base64.
   */
    export function convertFileToBase64(file: File): Promise<string> {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
      });
    }